module.exports = __webpack_public_path__ + "static/media/newpageguide.850824faf3833679a90d98bbd5da94bb.svg";